import WithTooltip from './WithTooltip';

export default WithTooltip;
